import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ErrorAlertData } from '@shared/error-alert/error-alert.component';
import { NotifyUserService } from '@shared/notify-user.service';
import { downloadFile, formatBytes, MimeTypes } from '@shared/shared-functions';
import { filter, tap } from 'rxjs/operators';

@Component({
    selector: 'fb-files-upload',
    templateUrl: './files-upload.component.html',
    styleUrls: ['./files-upload.component.scss'],
})
export class FilesUploadComponent implements OnInit {
    @Input()
    descrizioneImportazione: string = 'Importa uno o più file';

    @Input()
    extensionsAllowed: Array<'txt' | 'pdf' | 'xml'| 'json'>;

    @Input()
    multipleFileUpload = true;

    @Input()
    filesLimit: number;

    @Input()
    confermaImportazioneDisabled = false;

    @Input()
    fileOverflowLimit = 3;

    @Output()
    confirmUploadedFilesEvent = new EventEmitter<Array<File>>();

    @Output()
    confirmDeletedFileEvent = new EventEmitter<File>();

    @Input()
    uploadedFiles = new Array<File>();

    @Input()
    canEditFiles = true;

    showConfirmActionButton = false;

    alertData: ErrorAlertData;

    constructor(private notifyUserService: NotifyUserService) {}

    ngOnInit(): void {}

    onFileSelected(event: any) {
        const files = <FileList>event.target.files;
        this.alertData = null;

        if (!files.length) {
            return;
        }

        if (this.multipleFileUpload === true && this.filesLimit && files.length > this.filesLimit) {
            this.alertData = new ErrorAlertData(
                `Il numero massimo di file che puoi caricare è <span class="text-semibold">${this.filesLimit}</span>.`,
                `Hai caricato <span class="text-semibold">${files.length}</span> file.`
            );
            return;
        }

        this.handleFiles(files);
    }

    handleFiles(fileList: FileList) {
        this.showConfirmActionButton = true;

        console.warn('handleFiles', fileList);
        this.showConfirmActionButton = true;

        for (const file of fileList) {
            // Controllo se il file ha l'estensione corretta soltanto se l'array di estensioni consentite è valorizzato
            if (this.extensionsAllowed && this.fileHasCorrectExtension(file) === false) continue;

            // Se c'è la possibilità di caricare un solo file e ce n'è già uno caricato elimino quello precedentemente caricato
            if (this.multipleFileUpload === false && this.uploadedFiles.length === 1) this.uploadedFiles.length = 0;

            this.overwriteOrPushUploadedFile(this.uploadedFiles, file);
        }
    }

    fileHasCorrectExtension(file: File) {
        console.warn('fileHasCorrectExtension', file);
        const fileHasCorrectExtension = Boolean(this.extensionsAllowed?.find(x => MimeTypes[x] === file.type));

        console.log('fileHasCorrectExtension', this.extensionsAllowed, file.type);
        
        if (fileHasCorrectExtension === false) {
            this.alertData = new ErrorAlertData(
                `Il file <span class="text-italic">${file.name}</span> non può essere importato.`,
                `Solo i file con estensione <span class="text-semibold">${this.extensionsAllowed.join(', ')}</span> sono ammessi`
            );
        }

        return fileHasCorrectExtension;
    }

    formatBytes(bytes, decimals = 2) {
        return formatBytes(bytes, decimals);
    }

    onConfermaUpload() {
        this.confirmUploadedFilesEvent.emit(this.uploadedFiles);
        this.showConfirmActionButton = false;
    }

    onDeleteFile(file: File) {
        this.notifyUserService
            .showConfirmModal('Conferma richiesta', `Sei sicuro di voler eliminare il file <span class="text-semibold">${file.name}</span>?`)
            .afterClosed()
            .pipe(
                filter(result => result === true),
                tap(() => this.uploadedFiles.splice(this.uploadedFiles.indexOf(file), 1)),
                tap(() => this.confirmDeletedFileEvent.emit(file)),
                tap(() => (this.alertData = null))
            )
            .subscribe();
    }

    onDownloadFile(file: File) {
        const url = URL.createObjectURL(file);
        downloadFile(url, file.name);
        URL.revokeObjectURL(url);
    }

    private overwriteOrPushUploadedFile(files: Array<File>, uploadedFile: File) {
        const existingFileIndex = files.findIndex(file => file.name === uploadedFile.name);

        if (existingFileIndex !== -1) {
            files[existingFileIndex] = uploadedFile;
            return;
        }

        files.push(uploadedFile);
    }
}
